import Vue from 'vue'

let Utilities = {
  'date_plurals': {
    'years': {
      'one': 'год',
      'two': 'года',
      'many': 'лет',
    },
    'months': {
      'one': 'месяц',
      'two': 'месяца',
      'many': 'месяцев',
    },
    'days': {
      'one': 'день',
      'two': 'дня',
      'many': 'дней',
    },
  },
  monthes: {
    en: {
      short: [
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC'
      ],
      full: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    },
    ru: {
      short: [
        'Янв',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Июн',
        'Июл',
        'Авг',
        'Сен',
        'Окт',
        'Ноя',
        'Дек'
      ],
      full: [
        'Января',
        'Февраля',
        'Марта',
        'Апреля',
        'Мая',
        'Июня',
        'Июля',
        'Августа',
        'Сентября',
        'Октября',
        'Ноября',
        'Декабря'
      ]
    },
    uk: {
      short: [
        'Ciч',
        'Лют',
        'Бер',
        'Квi',
        'Тра',
        'Чер',
        'Лип',
        'Сер',
        'Вер',
        'Жов',
        'Лис',
        'Гру'
      ],
      full: [
        'Сiчня',
        'Лютого',
        'Березня',
        'Квiтня',
        'Травня',
        'Червня',
        'Липня',
        'Серпня',
        'Вересня',
        'Жовтня',
        'Листопада',
        'Грудня'
      ]
    }
  },
  days: {
    en: {
      short: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ],
      full: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ]
    },
    ru: {
      short: [
        'Вс',
        'Пн',
        'Вт',
        'Ср',
        'Чт',
        'Пт',
        'Сб'
      ],
      full: [
        'Воскресенье',
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота'
      ]
    },
    uk: {
      short: [
        'Вс',
        'Пн',
        'Вт',
        'Ср',
        'Чт',
        'Пт',
        'Сб'
      ],
      full: [
        'Недiля',
        'Понедiлок',
        'Вiвторок',
        'Середа',
        'Четвер',
        'П\'ятница',
        'Субота'
      ]
    }
  },
  /**
   * Возвращает дату относительно указанного смещения в указанном формате
   * @param dateString {string}|{object} Смещение даты или объект Date. в случае передачи объекта Date будет возвращена дата в соответствии с форматом.
   * Формат смещения: ([0-9]*day|week|month)|(today|tomorrow|yesterday), например: 2day - на два дня вперед, yesterday - вчера.
   * Регистр значения не имеет.
   * При неправильно указанном смещении принимается значение today.
   * При других ошибках возвращается пустая строка.
   * @param format {string} Формат возвращаемой даты:
   * H - часы в формате 24
   * i - минуты
   * d - день месяца, число от 1 до 31
   * D - день недели, сокращенный вариант
   * l (L в нижнем регистре) - день недели, полный вариант
   * m - месяц, число от 1 до 12
   * M - месяц, сокращенный вариант
   * F - месяц, полный вариант
   * y - год в формате ГГ
   * Y - год в формате ГГГГ
   * По умолчанию d.m.Y
   * @param language {string} Локаль для вывода строковых значений месяца и дня недели.
   * Регистр значения не имеет.
   * По умолчанию en.
   * @param returnObject {boolean} Если установлен в в true,
   * то вместо форматированной строки вернется сформированный объект Date
   * @returns {string | Date | boolean}
   */
  createDate(dateString, format = 'm/d/Y', language = 'en', returnObject = false) {
    var languageRegexp = /^(en|ru|uk)$/i
    var now = new Date()
    var createdDate
    /* По умолчанию возвращаем строку */
    returnObject = typeof returnObject === 'undefined' ? false : returnObject
    /* Формат по умолчанию - дд.мм.ГГГГ, если входящий формат не определен */
    format = typeof format === 'undefined' ? 'd.m.Y' : format
    /* Язык по умолчанию - en */
    language = typeof language === 'undefined' ? 'en' : language
    language = languageRegexp.test(language) === false ? 'en' : language.toLowerCase()
    /* Формируем объект целевой даты */
    var dateRegexp = /^([-+0-9]{0,})*(second|minute|hour|day|week|month|year)s{0,1}$/i

    if (dateString instanceof Date) {
      createdDate = dateString
    } else {
      var dateComponents = dateRegexp.exec(dateString)
      if (dateComponents) {
        /* Если дата указана в формате диапазона - разбираем ее */
        var range = typeof dateComponents[1] === 'undefined' ? 1 : Number(dateComponents[1])
        switch (dateComponents[2].toLowerCase()) {
          case 'second': {
            createdDate = new Date(now.setSeconds(now.getSeconds() + range))
            break
          }
          case 'minute': {
            createdDate = new Date(now.setMinutes(now.getMinutes() + range))
            break
          }
          case 'hour': {
            createdDate = new Date(now.setHours(now.getHours() + range))
            break
          }
          case 'day': {
            createdDate = new Date(now.setDate(now.getDate() + range))
            break
          }
          case 'week': {
            range = range * 7
            createdDate = new Date(now.setDate(now.getDate() + range))
            break
          }
          case 'month': {
            createdDate = new Date(now.setMonth(now.getMonth() + range))
            break
          }
          case 'year': {
            createdDate = new Date(now.setYear(now.getFullYear() + range))
            break
          }
          default: {
            // console.error("Wrong date range: ", dateString);
            return ''
          }
        }
      } else {
        /* Проверим на текстовое указание диапазона */
        switch (dateString) {
          case 'now':
          case 'today': {
            createdDate = now
            break
          }
          case 'yesterday': {
            createdDate = new Date(now.setDate(now.getDate() - 1))
            break
          }
          case 'tomorrow': {
            createdDate = new Date(now.setDate(now.getDate() + 1))
            break
          }
          default: {
            // console.error("Wrong day: ", dateString);
            return ''
          }
        }
      }
    }

    if (returnObject) {
      return createdDate
    }

    /* Формируем выходную строку в соответствии указанным форматом */
    /**
     * Таблица преобразования: (основана на функции date() http://www.php.net/manual/en/function.date.php)
     * H - часы в формате 24
     * i - минуты
     * d - день месяца, число от 1 до 31
     * D - день недели, сокращенный вариант
     * l (L в нижнем регистре) - день недели, полный вариант
     * m - месяц, число от 1 до 12
     * M - месяц, сокращенный вариант
     * F - месяц, полный вариант
     * y - год в формате ГГ
     * Y - год в формате ГГГГ
     *
     * все остальные символы, переданные в строке формата, выводятся как есть
     * */
    var outputString = ''
    for (var formatIndex = 0; formatIndex < format.length; formatIndex++) {
      var convertedValue = ''
      switch (format.charAt(formatIndex)) {
        case 'H' : {
          var hours = createdDate.getHours()
          convertedValue = hours < 10 ? '0' + hours : hours
          break
        }
        case 'i': {
          var minutes = createdDate.getMinutes()
          convertedValue = minutes < 10 ? '0' + minutes : minutes
          break
        }
        case 's': {
          var seconds = createdDate.getSeconds()
          convertedValue = seconds < 10 ? '0' + seconds : seconds
          break
        }
        case 'd': {
          var dayNumber = createdDate.getDate()
          convertedValue = dayNumber < 10 ? '0' + dayNumber : dayNumber
          break
        }
        case 'D': {
          var dayOfWeekShort = createdDate.getDay()
          if (this.days[language]) {
            convertedValue = this.days[language].short[dayOfWeekShort]
          } else {
            convertedValue = this.days.en.short[dayOfWeekShort]
          }
          break
        }
        case 'l': {
          var dayOfWeekFull = createdDate.getDay()
          if (this.days[language]) {
            convertedValue = this.days[language].full[dayOfWeekFull]
          } else {
            convertedValue = this.days.en.full[dayOfWeekFull]
          }
          break
        }
        case 'm': {
          var month = createdDate.getMonth() + 1
          convertedValue = month < 10 ? '0' + month : month
          break
        }
        case 'M': {
          var monthShort = createdDate.getMonth()
          if (this.monthes[language]) {
            convertedValue = this.monthes[language].short[monthShort]
          } else {
            convertedValue = this.monthes.en.short[monthShort]
          }
          break
        }
        case 'F': {
          var monthFull = createdDate.getMonth()
          if (this.monthes[language]) {
            convertedValue = this.monthes[language].full[monthFull]
          } else {
            convertedValue = this.monthes.en.full[monthFull]
          }
          break
        }
        case 'y': {
          var yearShort = createdDate.getFullYear()
          convertedValue = yearShort.toString().substring(2)
          break
        }
        case 'Y': {
          convertedValue = createdDate.getFullYear()
          break
        }
        default: {
          convertedValue = format.charAt(formatIndex)
          break
        }
      }
      outputString = outputString + convertedValue
    }
    return outputString
  },

  /**
   * Create Date object from dateString.
   * String format should be Y-m-d H:i:s.
   * @param {string} dateString
   */
  parseDateString(dateString) {
    var dateComponents, year, month, day, hours, seconds, minutes
    var dateRegexp = /([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})( ([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})){0,1}/
    var dateRegexp2 = /(([0-9]{1,2}):([0-9]{1,2})(:([0-9]{1,2}){0,1}) ){0,1}([0-9]{1,2})\.([0-9]{1,2})\.([0-9]{4})/
    if (dateRegexp.test(dateString)) {
      dateComponents = dateRegexp.exec(dateString)
      year = parseInt(dateComponents[1])
      month = parseInt(dateComponents[2]) - 1
      day = parseInt(dateComponents[3])
      if (typeof dateComponents[4] !== 'undefined') {
        hours = parseInt(dateComponents[5])
        minutes = parseInt(dateComponents[6])
        seconds = parseInt(dateComponents[7])
      } else {
        hours = 0
        minutes = 0
        seconds = 0
      }
    } else {
      if (dateRegexp2.test(dateString)) {
        dateComponents = dateRegexp2.exec(dateString)
        hours = typeof dateComponents[2] === 'undefined' ? 0 : parseInt(dateComponents[2])
        minutes = typeof dateComponents[3] === 'undefined' ? 0 : parseInt(dateComponents[3])
        seconds = typeof dateComponents[5] === 'undefined' ? 0 : parseInt(dateComponents[5])
        day = parseInt(dateComponents[6])
        month = parseInt(dateComponents[7]) - 1
        year = parseInt(dateComponents[8])
      } else {
        return ''
      }
    }

    return new Date(year, month, day, hours, minutes, seconds)
  },

  formatDate(inputValue, dateFormat, locale = 'en'){
    return Utilities.createDate(Utilities.parseDateString(inputValue), dateFormat, locale, false)
  },

  /**
   * @param {Date} firstDate
   * @param {Date} secondDate
   * @link https://stackoverflow.com/a/20669357
   */
  datesDiff(firstDate, secondDate) {
    const dateDiffMilliseconds = secondDate - firstDate,
      dateDiff = new Date(dateDiffMilliseconds),
      diff = {
        years: dateDiff.getUTCFullYear() - 1970,
        months: dateDiff.getUTCMonth(),
        days: dateDiff.getUTCDate() - 1,
        ms: dateDiffMilliseconds,
        text: null,
      };

    let References = Utilities;

    if (diff.ms < 0) {
      diff.text = `${References.date_plurals.days.many}`
    } else if (diff.years === 0 && diff.months === 0 && diff.days === 0 && diff.ms > 0) {
      diff.text = `1 ${References.date_plurals.days.one}` // пограничный случай, округляем до одного дня
    } else {
      diff.text = `${Utilities.pluralDate(diff.years, 'years')} ${Utilities.pluralDate(diff.months, 'months')} ${Utilities.pluralDate(diff.days, 'days')}`
    }

    return diff
  },

  /**
   * @param {int} num
   * @param {string} type    years|months|days
   */
  pluralDate(num, type) {
    if (num <= 0) {
      return ''
    }

    let References = Utilities;

    const plurals = References.date_plurals[type],
      numStr = num.toString(),
      lastDigit = parseInt(numStr.slice(-1)),
      lastTwoDigits = parseInt(numStr.slice(-2))
    let str

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
      str = plurals.many
    } else if (lastDigit === 1) {
      str = plurals.one
    } else if (lastDigit >= 2 && lastDigit <= 4) {
      str = plurals.two
    } else {
      str = plurals.many
    }

    return `${numStr} ${str}`
  },
}

Vue.filter('formatDate', function (inputValue, dateFormat) {
  var locale = 'en'

  try {
    // locale = Quasar.lang.getLocale() // returns a string
  } catch (e) {

  }

  return Utilities.formatDate(inputValue, dateFormat, locale)
})

export default Utilities


